import { rem } from 'polished'
import styled from 'styled-components'

import { TextField } from '../../../elements/TextField'

export const PaginationTextFieldStyled = styled((props) => (
  <TextField {...props} />
))`
  width: ${rem(52)};
`
